import React from 'react';
import { useRouter } from 'next/router';
import useSearchStore from '../store/searchStore';

function SearchInput() {
  const router = useRouter();
  
  const isSearchPage = router.pathname.startsWith('/search');

  const searchQuery = useSearchStore((state) => state.searchQuery);
  const setSearchQuery = useSearchStore((state) => state.setSearchQuery);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedQuery = (isSearchPage ? searchQuery : e.target.query.value).trim();
    if (trimmedQuery) {
      const formattedQuery = trimmedQuery.replace(/\s+/g, '-');
      router.push(`/search/${formattedQuery}`);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (isSearchPage) {
      // Update store when on search page
      setSearchQuery(value);
    }
  };

  return (
    <div className="col-span-4 w-full bg-white relative border border-black/10 rounded-2xl p-2.5 shadow-md">
      <form onSubmit={handleSubmit} className="relative flex items-center w-full">
        <img 
          src="/images/search_lens.svg" 
          alt="Search" 
          className="absolute left-2 top-[calc(50%+1px)] transform -translate-y-1/2 w-4 h-4"
        />
        <input
          type="text"
          name="query"
          placeholder="find any icon..."
          {...(isSearchPage ? { value: searchQuery } : {})}
          onChange={handleChange}
          id="search-query"
          className="border-none bg-transparent pl-8 text-base w-full h-8 text-gray-800 focus:outline-none placeholder:text-gray-500 pt-1 pb-1"
        />
        <button 
          type="submit" 
          className="absolute right-3 bg-transparent border-none cursor-pointer"
          aria-label="Search"
        >
          <img 
            src="/images/arrow-find.svg" 
            alt="search lens" 
            aria-hidden="true" 
            className="w-4 h-4"
          />
        </button>
      </form>
    </div>
  );
}

export default SearchInput;